import { motion } from 'framer-motion';
import { Building, Landmark, Users } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const clientTypes = [
  {
    icon: <Building className="w-10 h-10" />,
    title: 'MSMEs',
    items: ['Manufacturing units', 'Service enterprises', 'Trading businesses', 'Startups']
  },
  {
    icon: <Landmark className="w-10 h-10" />,
    title: 'Corporates',
    items: ['Large enterprises', 'Group companies', 'Industrial units', 'Export houses']
  },
  {
    icon: <Users className="w-10 h-10" />,
    title: 'Individuals',
    items: ['First-time entrepreneurs', 'Home buyers', 'Business professionals', 'Salaried individuals']
  }
];

export const WhyUsClients = () => (
  <section className="py-24" data-testid="clients-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Who We Serve
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          Our services cater to diverse client segments with tailored solutions.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8">
        {clientTypes.map((client, index) => (
          <motion.div
            key={client.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
          >
            <Card className="h-full border border-slate-100 hover:border-[#00bcd4]/30 transition-colors bg-white">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#3b5998] to-[#00bcd4] flex items-center justify-center text-white mx-auto mb-6">
                  {client.icon}
                </div>
                <h3 className="font-heading text-2xl font-semibold text-[#0f172a] mb-6">
                  {client.title}
                </h3>
                <ul className="space-y-3">
                  {client.items.map((item, i) => (
                    <li key={i} className="text-[#64748b] text-sm">
                      {item}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
